/* eslint-disable */

import CryptoJS from 'crypto-js';
import JSEncrypt from 'jsencrypt';
import axios from "axios";
import Qs from 'qs';
import {getConfigStorage, getToken, setStorage} from '../util';
// import store from "../store";
import router from "../router";
import Vue from 'vue';

let api_address = ''
if (process.env.NODE_ENV !== 'development') {
    // api_address = 'https://api.jy6789.xyz'
    api_address = ''
}


const clientPrivateKey = '-----BEGIN RSA PRIVATE KEY-----\n' +
    'MIICXQIBAAKBgQDvZgKw9gzcfoqrthpnQq+F9kkB+tBCP1QPDskPFCldrx7a0JFK\n' +
    'iD7KdrW+7XEAkkWOf1/9bJ2IeTzH3UubDcS9cmsUP/LTHt2W5m+dGBvN1yVmHSuO\n' +
    '23O2nRxuZ0juoKYEpFGcdNXqL228ZccBn7mtqnUlUnZYkYHC2UB6gS1CEQIDAQAB\n' +
    'AoGBAIWU/WFzGkAa2BPyfA8sdbahc6GIK5cbsTLpxCUG0gI1ilj80mWtWqQs00Mj\n' +
    'SM/RzsAxsQU/CzQwukqn3904NJORKzfejE9FzLdxlPBjOBjWNhFJC9qJyOAMFciP\n' +
    'fSFBihp+ZTy0L5CJaBKUyIJIISbL03vIRpZNYy3WTM80Uc4BAkEA+0WmL3ArX67P\n' +
    '7krtcAPqkOhR1swMp0Rj9M3+XrWaCdv3SgPqBy8tSZJDA5M2eeBe3h1YFueY7/Cu\n' +
    'm/rhoPfAIQJBAPPnKuPBUVNHEvpv0LuSfI3sjKPdAkQQ5mjXY+SNpA25goQa7ALd\n' +
    'RgCPUPFjol9nVXEanQWqWrZsuyey636RA/ECQFPkkDS8da7PldrQp2/DzvgsqM5X\n' +
    'eE4MdncQo8IJTfHGwEy0+9kENlGfBMLXztNoRyRPlc6n6pcJu7KWU+jDbyECQQCk\n' +
    'HoIyvUt+8Q1pLUJUZS6gxXKhdL7olEKme4EBMvoYLiMPx5nWF5TaHZXGyFdjQQIy\n' +
    'WEkendHqfOG2xeNGyEfRAkAjX+BqNGCoBB3ahYGyEp1PeYiY2bC0ZuFBfh/V6hAU\n' +
    'MnsMHmQtsex/Pb58I9iSbjr0O81rFETfED+S9nrL0EVG\n' +
    '-----END RSA PRIVATE KEY-----';


// 私钥解密
function decryptByPrivateKey(data, privateKey) {
    const decryptor = new JSEncrypt();
    decryptor.setPrivateKey(privateKey);
    return decryptor.decrypt(data);
}


// AES 解密业务数据：AES-128-ECB
function decryptByAesKey(data, aesKey) {
    return CryptoJS.AES.decrypt(data, CryptoJS.enc.Utf8.parse(aesKey), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8);
}


// 接口响应状态码
// code	说明
// 200	请求成功，非200为请求失败
// 1000	通用错误码
// 101x	解密密钥错误码
// 102x	签名验证错误码
// 103x	令牌验证错误码
// 1039	令牌过期错误码
// 9004	未绑邮箱错误码
// 9999	高频操作错误码

//增加全局设置
axios.interceptors.request.use(function (config) {


    let AccessToken = getToken();

    if (AccessToken !== null || AccessToken !== undefined) {
        config.headers['Access-Token'] = AccessToken;
    }

    return config;

}, function (error) {
    return Promise.reject(error);
});

//增加全局设置
let hasShownMessage = false
axios.interceptors.response.use(response => {
    // 响应Aes密钥密文
    const responseSecretKey = response.headers['secret-key']
    // 响应Aes密钥明文
    const responseAesKey = decryptByPrivateKey(responseSecretKey, clientPrivateKey)

    const decryptData = decryptByAesKey(response.data.encrypt_data, responseAesKey);
    // 解码结果
    // console.log('DecryptData:',JSON.parse(decryptData));

    const dataJSON = JSON.parse(decryptData)
    console.log(router.history.current.name)
    if(router.history.current.name !== 'home'){
        // 1039 1033 token过期
        if (dataJSON.code === 1039||dataJSON.code === 1033) {
            setStorage('userInfo', null)
            setStorage('tokenInfo', null)
            window.location = '/#/login'
            if (!hasShownMessage) {
                // 登录或注册页/首页/优惠页/客服页不弹登录失效信息
                if (window.location.pathname === '/login' || window.location.pathname === '/' || window.location.pathname === '/promo' || window.location.pathname === '/service') {
                } else {
                    Vue.prototype.$message({
                        // message: dataJSON['message'],
                        message: '请先登录后再操作',
                        type: 'error', // 提示类型：success, warning, info, error
                    });
                    hasShownMessage = true
                }
            }

            if (window.location.pathname === '/login' || window.location.pathname === '/' || window.location.pathname === '/promo' || window.location.pathname === '/service') {
                // 登录或注册页/首页/优惠页/客服页不再跳转
            } else {
                setTimeout(function () {
                    hasShownMessage = false
                    window.location = '/#/login'
                }, 2000)
                return
            }
        } else if (dataJSON.code === 1000) {
            Vue.prototype.$message({
                // message: dataJSON['message'],
                message: dataJSON.message,
                type: 'error', // 提示类型：success, warning, info, error
            });
        }
    }

    return dataJSON;
}, error => {
    console.log('error : ' + error.response)
    // console.log(error)
    // console.log(error.response)
    // console.log(error.response.status)
    /*if (error.response.status === 401) {
        document.getElementById('pop_des').style.display = 'block';
        document.getElementById('pop_des').innerText = '登录已失效' + error.response.data.Message;
        //异地登录后返回登录页只能响应一次
        if (clear_gotoLogin__offsite === true) {
            clear_gotoLogin__offsite = false;
            setTimeout(() => {
                //把localstorage中用户信息清空,并跳转至登录页面
                setStorage('userInfo', '');
                setStorage('userInfo', '');
                //todo 返回首页后必须刷新清空状态!!!!
                //开发环境直接返回/#/,开发环境移动端域名因为多了h5所以返回/h5/#/
                if (process.env.REACT_APP_ENV === 'pro') {
                    // window.location = '/h5/#/'
                    //todo 测试环境也使用 '/#/'
                    window.location = '/#/'
                    // setTimeout(()=>{
                    //     window.location.reload()
                    // },100)
                } else {
                    window.location = '/#/'
                    // setTimeout(()=>{
                    //     window.location.reload()
                    // },100)
                }
                window.location.reload()
            }, 2000)
        }
    }*/
    const obj = {
        status: error.response.status,
        message: error.response['data']['Message']
    }
    return Promise.reject(obj);
});


// 登录失效返回登录页监控
/*axios.interceptors.response.use(response => {
        const curStatus = response.data.dm_error

        if (curStatus === -1) {
            document.getElementById('pop_des').style.display = 'block';
            document.getElementById('pop_des').innerText = '登录失效,请从新登录';

            setTimeout(() => {
                document.getElementById('pop_des').style.display = 'none';
                //把localstorage中用户信息清空,并跳转至登录页面
                setStorage('userInfo', '');
                //todo 返回首页后必须刷新清空状态!!!!
                //开发环境直接返回/#/,开发环境移动端域名因为多了h5所以返回/h5/#/
                window.location = '/#/loginSign'
                window.location.reload()
            }, 2000)
        }
        return response
    }, error => {
        return Promise.reject(error)
    }
)*/


/* todo 登录 */
export const createLogin = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/passport/login`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 注册 */
export const createRegister = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/passport/register`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 配置信息 */
export const createSystemConfig = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);

    return await axios.post(api_address + `/api/system/config`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 获取用户信息 */
export const createUserInfo = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/member/info`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 获取账户余额 */
export const createBalance = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/member/balance`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 获取VIP进度 */
export const createVipProcess = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);

    return await axios.post(api_address + `/api/member/vipProcess`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};
/* todo 获取VIP进度 */
export const createTaskProcess = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);

    return await axios.post(api_address + `/api/member/taskProcess`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 获取系统公告 */
export const createSystemAnnounce = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);

    return await axios.post(api_address + `/api/system/announce`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 获取消息列表 */
export const createMessage = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);

    return await axios.post(api_address + `/api/message/list`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 设置已读 */
export const createMessageSetRead = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);

    return await axios.post(api_address + `/api/message/setRead`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 删除消息 */
export const createDeleteMessage = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);

    return await axios.post(api_address + `/api/message/delete`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 获取消息未读条数 */
export const createMessageUnreadCount = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);

    return await axios.post(api_address + `/api/message/unreadCount`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 获取vip信息 */
export const createVIPInfo = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/system/vip`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 获取活动列表 */
export const createActiveList = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/active/list`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 获取活动详细 */
export const createActiveDetail = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/active/detail`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 获取用户信息 */
export const createBanner = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/system/slide`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 验证码图片 */
export const createCaptcha = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/system/captcha`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 找回登录密码1 */
export const createFoundLoginPasswordOne = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/passport/foundLoginPasswordOne`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 找回登录密码2 */
export const createFoundLoginPasswordTwo = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/passport/foundLoginPasswordTwo`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 找回登录密码3 */
export const createFoundLoginPasswordThree = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/passport/foundLoginPasswordThree`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};


/* todo 重置提款密码1 */
export const createPhoneResetPasswordOne = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/withdraw/resetPasswordOne`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 重置提款密码2 */
export const createPhoneResetPasswordTwo = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/withdraw/resetPasswordTwo`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 发送验证码 */
export const createPhoneValidateCode = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/passport/sendSmsCode`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 发送邮箱验证码 */
export const createEmailValidateCode = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/member/sendEmailCode`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 用途标签 */
export const createUseTypeTag = async (obj) => {
    const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/usedTag`, data, {}).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 获取配置 */
export const createConfigInfo = async (obj) => {
    // const data = Qs.stringify(obj);
    return await axios.get(api_address + `/api/config/getConfig`, {}).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 用户信息绑定 */
export const createBindInfo = async (obj) => {
    const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/bindInfo`, data, {}).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 出借方快速借款 */
export const createFastLendOrder = async (obj) => {
    const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/createFastLendOrder`, data, {}).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 出款方分期借款 */
export const createFQLendOrder = async (obj) => {
    const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/createFQLendOrder`, data, {}).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 借款方快速借款 */
export const createFastLoanOrder = async (obj) => {
    const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/createFastLoanOrder`, data, {}).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 借款方分期借款 */
export const createFQLoanOrder = async (obj) => {
    const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/createFQLoanOrder`, data, {}).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 还款明细 */
export const createOrderExtensionList = async (obj) => {
    const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/orderExtensionList`, data, {}).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 支付密码修改验证码验证 */
export const createCheckCode = async (obj) => {
    const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/checkCode`, data, {}).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 修改支付密码 */
export const createModifyPWD = async (obj) => {
    const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/updatePaymentPassword`, data, {}).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 修改登录密码 */
export const createModifyLoginPWD = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/member/updateLoginPassword`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).catch(errs => {
        return errs;
    });
};

/* todo 设置生日日期 */
export const createSetBirthday = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/member/setBirthday`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).catch(errs => {
        return errs;
    });
};

/* todo 更新会员昵称 */
export const createUpdateNickname = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/member/updateNickname`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).catch(errs => {
        return errs;
    });
};

/* todo 验证手机号码 */
export const createSetPhone = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/member/verifyMobile`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).catch(errs => {
        return errs;
    });
};

/* todo 验证email */
export const createSetEmail = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/member/verifyEmail`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).catch(errs => {
        return errs;
    });
};

/* todo 借条签名 */
export const createOrderSign = async (obj) => {
    const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/orderSign`, data, {}).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 借条列表 */
export const createOrderList = async (obj) => {
    const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/orderList`, data, {}).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 借条详情 */
export const createOrderDetail = async (obj) => {
    const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/orderDtail`, data, {}).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 删除借条 */
export const createDeleteOrder = async (obj) => {
    const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/deleteOrder`, data, {}).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 钱包支付列表 */
export const createOrderPayList = async (obj) => {
    const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/orderPayList`, data, {}).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 视频活体验证 */
export const createFaceVerify = async (obj) => {
    const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/faceVerify`, obj, {}).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 标记已还 */
export const createSetOrderTag = async (obj) => {
    const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/updateOrderRepayment`, data, {}).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 还款审批 */
export const createCheckRepayment = async (obj) => {
    const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/checkRepayment`, data, {}).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 展期审批 */
export const createCheckExtension = async (obj) => {
    const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/checkExtension`, data, {}).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 标记展期 */
export const createSetExceedTag = async (obj) => {
    const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/applyOrderRepaymentExtension`, data, {}).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 申请列表 */
export const createApplyList = async (obj) => {
    const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/orderExtensionList`, data, {}).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 支付密码验证 */
export const checkPaymentPassword = async (obj) => {
    const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/checkPaymentPassword`, data, {}).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 上传头像图片base64 */
export const createUploadImg = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/member/uploadAvatar`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};


/* todo 游戏平台 */
export const createGamePlatform = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/game/platform`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 游戏列表 */
export const createGameList = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/game/list`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 登录游戏 */
export const createPlayGameList = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/game/play`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 最近游戏 */
export const createHistoryGameList = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/game/historyList`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 收藏游戏列表 */
export const createCollectGameList = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/game/collectList`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 收藏游戏 */
export const createCollectGame = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/game/collect`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 热门游戏 */
export const createHotGameList = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/game/hot`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 存款通道 */
export const createDepositChannelList = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/deposit/channelList`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 存送活动 */
export const createDepositActivityList = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/deposit/activityList`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 提交存款申请 */
export const createDepositSubmit = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/deposit/submit`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo USDT汇率 */
export const createUsdtRate = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/deposit/usdtRate`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo USDT取款汇率 */
export const createWithdrawUsdtRate = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/withdraw/usdtRate`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 提款账户 */
export const createWithdrawAccountList = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/withdraw/accountList`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 删除提款账户 */
export const createDeleteWithdrawAccount = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/withdraw/accountDelete`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 设置提款密码 */
export const createSetWithdrawPassword = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/withdraw/setPassword`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 更新提款密码 */
export const createResetWithdrawPassword = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/withdraw/updatePassword`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 提款银行 */
export const createBankList = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/withdraw/bankList`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 绑定银行账户 */
export const createBankAccountBind = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/withdraw/accountBind`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 查询提款账户 */
export const createCheckAccountBind = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/withdraw/accountList`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 存款记录 */
export const createTransactionDepositLog = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/transaction/deposit`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 提款记录 */
export const createTransactionWithdrawLog = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/transaction/withdraw`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 专属网址 */
export const createMemberDomain = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/member/domain`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 反馈列表 */
export const createFeedbackList = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/feedback/list`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 提交反馈 */
export const createFeedbackSubmit = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/feedback/submit`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 反馈分类 */
export const createFeedbackCategory = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/feedback/category`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 团队推广 */
export const createRewardMyTeamList = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/reward/myTeamList`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 领取通宝佣金 */
export const createRewardApply = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/reward/rewardApply`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 推广赚钱数据 */
export const createRewardPopularMoney = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/reward/popularMoney`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 我的推广数据 */
export const createRewardMyDirect = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/reward/myDirect`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 团队推广数据 */
export const createRewardMyTeam = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/reward/myTeam`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 推广教程数据 */
export const createRewardPopularRule = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/reward/popularRule`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 积分规则 */
export const createMallRule = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/mall/rule`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 积分余额 */
export const creatMemberPoints = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/member/points`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 积分商品 */
export const createMallGoods = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/mall/goods`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 兑换商品 */
export const createMallGoodsExchange = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/mall/exchange`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 积分记录 */
export const createMallLog = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/mall/log`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 转账记录 */
export const createTransactionTransferLog = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/transaction/transfer`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 优惠记录 */
export const createPromoLog = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/transaction/promo`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 红利记录 */
export const createBonusLog = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/transaction/bonus`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 提交提款申请 */
export const createWithdrawSubmit = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/withdraw/submit`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 客服信息 */
export const createService = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/system/service`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 返水 */
export const createRebate = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/activity/rebate`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 返水领取 */
export const createRebateApply = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/activity/rebateApply`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 白菜 */
export const createCoupon = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/activity/coupon`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 白菜条数 */
export const createCouponCount = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/activity/couponCount`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 白菜领取 */
export const createCouponApply = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/activity/couponApply`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 彩金 */
export const createCouponCode = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/activity/couponCode`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 彩金领取 */
export const createCouponCodeApply = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/activity/couponCodeApply`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 复活 */
export const createHelper = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/activity/helper`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 复活领取 */
export const createHelperApply = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/activity/helperApply`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 生日礼金 */
export const createBirthday = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/activity/birthday`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 生日礼金领取 */
export const createBirthdayApply = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/activity/birthdayApply`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};
/* todo 荣耀礼金领取 */
export const createHonorApply = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/activity/honorApply`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 免费筹码 */
export const createChip = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/activity/chip`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 免费筹码领取 */
export const createChipApply = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/activity/chipApply`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 晋级礼金 */
export const createUpgrade = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/activity/upgrade`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 荣耀彩金 */
export const gloryBonus = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/activity/honor`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};

/* todo 晋级礼金领取 */
export const createUpgradeApply = async (obj, secretKey) => {
    // const data = Qs.stringify(obj);
    return await axios.post(api_address + `/api/activity/upgradeApply`, obj, {
        headers: {
            'content-type': 'application/json',
            'Secret-Key': secretKey
        }
    }).then(res => {
        return res;
    }).catch(errs => {
        return errs;
    });
};
